import { FeatureFlags } from '@environments/environment.interface';
import { environment } from '@environments/environment';
import { isProductionLike } from './environment-utils';

// Re-export from the leaf module so existing consumers don't need to change imports.
export { MOCK_FLAG_DEFINITIONS, MOCK_FLAG_KEYS } from './mock-flag-definitions';
export type { MockFlagDefinition } from './mock-flag-definitions';

import { MOCK_FLAG_DEFINITIONS } from './mock-flag-definitions';

/**
 * Whether any HTTP mock feature flag is active.
 * Used to gate MockApiInterceptor registration in app.config.ts.
 * Always returns false in production and staging (defense-in-depth).
 */
export function isAnyHttpMockActive(features?: Partial<FeatureFlags>): boolean {
  if (isProductionLike()) return false;
  const f = features ?? environment.features;
  return MOCK_FLAG_DEFINITIONS.some(def => f?.[def.key]);
}

/**
 * Whether any WebSocket-affecting mock flag is active.
 * Used to gate MockWebSocketService provider in app.config.ts.
 * Only a subset of mock flags affect WebSocket — Tenant, SymbolMapping, and
 * Schema are HTTP-only domains with no WebSocket channels.
 */
export function isAnyWsMockActive(features?: Partial<FeatureFlags>): boolean {
  if (isProductionLike()) return false;
  const f = features ?? environment.features;
  return MOCK_FLAG_DEFINITIONS.some(def => def.affectsWebSocket && f?.[def.key]);
}

/**
 * Returns display labels for all currently active mock flags.
 * Used by the mock data warning banner in AppComponent.
 */
export function getActiveMockLabels(features?: Partial<FeatureFlags>): string[] {
  if (isProductionLike()) return [];
  const f = features ?? environment.features;
  return MOCK_FLAG_DEFINITIONS
    .filter(def => f?.[def.key])
    .map(def => def.label);
}
